<template>
  <span class="has-text-weight-bold" :class="presenter.class">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.status === 'active' || this.status === 'pending') {
        presenter.class = 'has-text-success'
        presenter.label = 'Active'
      } else {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Inactive'
      }
      return presenter
    }
  },
  props: ['status']
}
</script>
